import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { BaseUrl } from '../../API/ApiHandle';

// Icons
import { RiLoginBoxLine, RiLogoutBoxLine } from "react-icons/ri";
import { LuFileQuestion } from "react-icons/lu";
import { GrUserAdmin } from "react-icons/gr";
import { BiSupport } from "react-icons/bi";
import { IoHomeOutline } from "react-icons/io5";
import { FaBars } from "react-icons/fa";
import { RiCloseCircleLine } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";
import { HiOutlineDocumentReport } from "react-icons/hi";

import './HomeNave.scss';

// Logo
import logo from '../../Assets/Images/New_logo_2.png';
import logo2 from '../../Assets/Images/New_logo.png';
import defaultProfileImg from '../../Assets/Images/profile.png';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { isRTL } from '../../helpers/handlertl';


export default function HomeNave({ role }) {
    const [Hide, setHide] = useState(false);
    const { pathname } = useLocation();
    const navigate = useNavigate()
    const [rqm, , removeCookie] = useCookies(['rqm']);
    const { i18n } = useTranslation();

    // Check if user is logged in
    const isLoggedIn = !!rqm.rqm;

    const PersonalImage = localStorage.getItem("Personal") ? JSON.parse(localStorage.getItem("Personal")) : defaultProfileImg;


    const Logout = async () => {
        await axios.get(`${BaseUrl}/logout`, {
            headers: {
                Authorization: `Bearer ${rqm.rqm}`
            }
        })
            .then((res) => {
                localStorage.clear();
                if (res.data.Done) {
                    removeCookie('rqm', { path: '/' });
                    localStorage.clear()
                    window.location.reload();
                    navigate('/')
                }
            })
            .catch((err) => {
                console.log(err);
                removeCookie('rqm', { path: '/' });
                localStorage.clear();
                window.location.reload();
                navigate('/');
            })
    }

    const handleHide = () => {
        setHide(!Hide)
    }

    const HandleNavigate = (Link) => {
        navigate(Link);
        setHide(false)
    }


    const navItemVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: (custom) => ({
            opacity: 1,
            y: 0,
            transition: { delay: custom * 0.1, duration: 0.5 }
        }),
    };

    const toggleLang = () => {
        const newLang = i18n.language === 'ar' ? 'en' : 'ar';
        i18n.changeLanguage(newLang);
        localStorage.setItem('i18nextLng', newLang);
    };

    useEffect(() => {
        const storedLanguage = localStorage.getItem('i18nextLng');
        if (storedLanguage) {

            i18n.changeLanguage(storedLanguage.toLowerCase());
        }
    }, [i18n]);

    const mobileMenuVariants = {
        closed: { opacity: 0, x: "100%" },
        open: { opacity: 1, x: 0, transition: { type: "spring", stiffness: 300, damping: 30 } }
    };

    if (role === "viewer") {
        return (
            <>
                <motion.nav
                    className="top-nav-container"
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <div className="top-nav-content">
                        <motion.div
                            className="top-nav-logo"
                            whileHover={{ scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 400, damping: 10 }}
                        >
                            <img src={logo2} alt="Logo" onClick={() => HandleNavigate('/')} />
                        </motion.div>

                        <div className="top-nav-links" dir={isRTL() ? 'rtl' : "ltr"}>
                            <motion.div
                                className={pathname === "/" ? 'nav-item active' : 'nav-item'}
                                onClick={() => HandleNavigate('/')}
                                variants={navItemVariants}
                                custom={0}
                                initial="hidden"
                                animate="visible"
                                whileHover="hover"
                                dir={isRTL() ? 'rtl' : "ltr"}
                            >
                                <IoHomeOutline className={`nav-icon`} />
                                <span>{t("Homeviewernav")}</span>
                            </motion.div>
                            <motion.div
                                className={pathname === "/reports" ? 'nav-item active' : 'nav-item'}
                                onClick={() => HandleNavigate('/reports')}
                                variants={navItemVariants}
                                custom={1}
                                initial="hidden"
                                animate="visible"
                                whileHover="hover"
                                dir={isRTL() ? 'rtl' : "ltr"}
                            >
                                <HiOutlineDocumentReport className="nav-icon " />
                                <span>{t("Reports")}</span>
                            </motion.div>

                            <motion.div
                                className={pathname === "/aboutus" ? 'nav-item active' : 'nav-item'}
                                onClick={() => HandleNavigate('/aboutus')}
                                variants={navItemVariants}
                                custom={2}
                                initial="hidden"
                                animate="visible"
                                whileHover="hover"
                                dir={isRTL() ? 'rtl' : "ltr"}
                            >
                                <LuFileQuestion className="nav-icon" />
                                <span>{t("AboutUs")}</span>
                            </motion.div>

                            <motion.div
                                className={pathname === "/Support" ? 'nav-item active' : 'nav-item'}
                                onClick={() => HandleNavigate('/Support')}
                                variants={navItemVariants}
                                custom={3}
                                initial="hidden"
                                animate="visible"
                                whileHover="hover"
                                dir={isRTL() ? 'rtl' : "ltr"}
                            >
                                <BiSupport className="nav-icon" />
                                <span>{t("Support")}</span>
                            </motion.div>

                            {!isLoggedIn && (
                                <motion.div
                                    className={pathname === "/Auth/Login" ? 'nav-item active' : 'nav-item'}
                                    onClick={() => HandleNavigate('/Auth/Login')}
                                    variants={navItemVariants}
                                    custom={4}
                                    initial="hidden"
                                    animate="visible"
                                    whileHover="hover"
                                    dir={isRTL() ? 'rtl' : "ltr"}
                                >
                                    <RiLoginBoxLine className="nav-icon" />
                                    <span>{t("Login")}</span>
                                </motion.div>
                            )}

                            {isLoggedIn && (
                                <>
                                    <motion.div
                                        className="nav-item logout-btn"
                                        onClick={Logout}
                                        variants={navItemVariants}
                                        custom={4}
                                        initial="hidden"
                                        animate="visible"
                                        whileHover="hover"
                                    >
                                        <RiLogoutBoxLine className="nav-icon" />
                                        <span>{t("Logout")}</span>
                                    </motion.div>

                                    <motion.div
                                        className={pathname === "/profile" ? 'nav-item profile-item active' : 'nav-item profile-item'}
                                        onClick={() => HandleNavigate('/profile')}
                                        variants={navItemVariants}
                                        custom={5}
                                        initial="hidden"
                                        animate="visible"
                                        whileHover="hover"
                                    >
                                        <div className="profile-image-container">
                                            <img
                                                src={PersonalImage}
                                                alt="Profile"
                                                className="profile-image"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = defaultProfileImg;
                                                }}
                                            />
                                        </div>
                                    </motion.div>
                                </>
                            )}
                            <motion.div
                                className="nav-item"
                                onClick={toggleLang}
                                whileHover={{ scale: 1.05 }}
                            >
                                <span>{i18n.language === 'en' ? 'عربى' : 'EN'}</span>
                            </motion.div>
                        </div>

                        <div className="mobile-menu-toggle" onClick={handleHide}>
                            {Hide ? <RiCloseCircleLine /> : <FaBars />}
                        </div>
                    </div>
                </motion.nav>

                <AnimatePresence>
                    {Hide && (
                        <motion.div
                            className="mobile-menu"
                            variants={mobileMenuVariants}
                            initial="closed"
                            animate="open"
                            exit="closed"
                        >
                            <div className="mobile-menu-items">
                                <motion.div
                                    className={pathname === "/" ? 'mobile-nav-item active' : 'mobile-nav-item'}
                                    onClick={() => HandleNavigate('/')}
                                    whileHover={{ scale: 1.05, x: 10 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                >
                                    <IoHomeOutline className="nav-icon" />
                                    <span>{t("Homeviewernav")}</span>
                                </motion.div>

                                <motion.div
                                    className={pathname === "/aboutus" ? 'mobile-nav-item active' : 'mobile-nav-item'}
                                    onClick={() => HandleNavigate('/aboutus')}
                                    whileHover={{ scale: 1.05, x: 10 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                >
                                    <LuFileQuestion className="nav-icon" />
                                    <span>{t("AboutUs")}</span>
                                </motion.div>

                                <motion.div
                                    className={pathname === "/Support" ? 'mobile-nav-item active' : 'mobile-nav-item'}
                                    onClick={() => HandleNavigate('/Support')}
                                    whileHover={{ scale: 1.05, x: 10 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                >
                                    <BiSupport className="nav-icon" />
                                    <span>{t("Support")}</span>
                                </motion.div>

                                {!isLoggedIn && (
                                    <motion.div
                                        className={pathname === "/Auth/Login" ? 'mobile-nav-item active' : 'mobile-nav-item'}
                                        onClick={() => HandleNavigate('/Auth/Login')}
                                        whileHover={{ scale: 1.05, x: 10 }}
                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                    >
                                        <RiLoginBoxLine className="nav-icon" />
                                        <span>{t("Login")}</span>
                                    </motion.div>
                                )}

                                {isLoggedIn && (
                                    <>
                                        <motion.div
                                            className={pathname === "/profile" ? 'mobile-nav-item active' : 'mobile-nav-item'}
                                            onClick={() => HandleNavigate('/profile')}
                                            whileHover={{ scale: 1.05, x: 10 }}
                                            transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                        >
                                            <CgProfile className="nav-icon" />
                                            <span>{t("Profile")}</span>
                                        </motion.div>

                                        <motion.div
                                            className="mobile-nav-item logout-btn"
                                            onClick={Logout}
                                            whileHover={{ scale: 1.05, x: 10 }}
                                            transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                        >
                                            <RiLogoutBoxLine className="nav-icon" />
                                            <span>{t("Logout")}</span>
                                        </motion.div>
                                    </>
                                )}

                                <motion.div
                                    className="mobile-nav-item"
                                    onClick={toggleLang}
                                    whileHover={{ scale: 1.05, x: 10 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                >
                                    <span>{i18n.language === 'en' ? 'عربى' : 'EN'}</span>
                                </motion.div>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </>
        );
    }

    return (
        <>
            <div className={Hide ? "dropback apper-dropback" : "dropback"} onClick={handleHide}>
            </div>
            <aside className={Hide ? 'allnav' : 'allnav apper'} >
                <div>
                    <img className="Logo-colaps" src={logo} loading='lazy' alt='Logo' />

                    {role === "analyst" ? (
                        <div className="h-[300px] flex flex-col gap-y-1 mt-9">
                            <p onClick={() => HandleNavigate('/analyst')} className={pathname === "/analyst" ? 'Active' : ''}><IoHomeOutline className='icon' /></p>
                            <p onClick={() => HandleNavigate('/analyst/aboutus')} className={pathname === "/analyst/aboutus" ? 'Active' : ''}><LuFileQuestion className='icon' /></p>
                            <p onClick={() => HandleNavigate('/analyst/Support')} className={pathname === "/analyst/Support" ? 'Active' : ''}><BiSupport className='icon' /></p>
                        </div>
                    ) : role === "admin" ? (
                        <div className="h-[300px] flex flex-col gap-y-1 mt-9">
                            <p onClick={() => HandleNavigate('')} className={pathname === "/admin" ? 'Active' : ''}><IoHomeOutline className='icon' /></p>
                            <p onClick={() => HandleNavigate('/dashboard')} className={pathname === "/admin/dashboard" ? 'Active' : ''}><GrUserAdmin className='icon' /></p>
                            <p onClick={() => HandleNavigate('aboutus')} className={pathname === "/admin/aboutus" ? 'Active' : ''}><LuFileQuestion className='icon' /></p>
                            <p onClick={() => HandleNavigate('Support')} className={pathname === "/admin/Support" ? 'Active' : ''}><BiSupport className='icon' /></p>
                        </div>
                    ) : null}
                </div>

                {isLoggedIn ? (
                    <RiLogoutBoxLine className='icon Logout cursor-pointer text-white' onClick={Logout} />
                ) : null}
            </aside>

            <span className='bars' onClick={handleHide}>
                {Hide ? <RiCloseCircleLine /> : <FaBars />}
            </span>
        </>
    );
}